const filterZeroAmounts = (data: any[]): any[] =>
  data.reduce((acc, item) => {
    const children = filterZeroAmounts(item.data || []);

    if (item.closing_amount !== 0 || children.length) {
      acc.push({ ...item, data: children });
    }
    return acc;
  }, []);

export const getprocessedData = (subHeader: string, singleData: any): any => {
  if (subHeader === "INVENTORY" && singleData?.data?.length) {
    return {
      ...singleData,
      data: filterZeroAmounts(singleData.data),
    };
  }
  return singleData;
};
